import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  LOAD_VEHICLES_LIST,
  CREATE_VEHICLES,
  EDIT_VEHICLES_BY_ID,
  LOAD_VEHICLES_BY_ID,
  DELETE_VEHICLES,
} from './actions';
import { AGENCY_MODULE } from '../../configs/moduleNames';
import {
  createLoadListReducerWithBegin,
  createOperationStateReducer,
  updateLoadParameterReducer,
} from '../../utils/getCrudConfig';

const initialState = {
  vehiclesListMeta: {},
  vehiclesListLinks: {},
  loadingVehiclesList: false,
  vehiclesList: [],
  loadingCurrentVehicles: false,
  currentVehicles: {},
  loadingCreateVehicles: false,
  loadingEditVehiclesById: false,
  loadingDeleteVehicles: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(AGENCY_MODULE + LOAD_VEHICLES_LIST, 'vehiclesList', 'loadingVehiclesList'),
  ...updateLoadParameterReducer(AGENCY_MODULE + LOAD_VEHICLES_BY_ID, 'currentVehicles', 'loadingCurrentVehicles', {}),
  ...createOperationStateReducer(AGENCY_MODULE + CREATE_VEHICLES, 'loadingCreateVehicles'),
  ...createOperationStateReducer(AGENCY_MODULE + EDIT_VEHICLES_BY_ID, 'loadingEditVehiclesById'),
  ...createOperationStateReducer(AGENCY_MODULE + DELETE_VEHICLES, 'loadingDeleteVehicles'),
}, initialState);

export default reducer;

export const getVehiclesData = createSelector(
  [state => state[AGENCY_MODULE]],
  state => {
    const {
      vehiclesListMeta,
      vehiclesListLinks,
      loadingVehiclesList,
      vehiclesList,
      loadingCurrentVehicles,
      currentVehicles,
      loadingCreateVehicles,
      loadingEditVehiclesById,
      loadingDeleteVehicles,
    } = state;
    return {
      vehiclesListMeta,
      vehiclesListLinks,
      loadingVehiclesList,
      vehiclesList,
      loadingCurrentVehicles,
      currentVehicles,
      loadingCreateVehicles,
      loadingEditVehiclesById,
      loadingDeleteVehicles,
    };
  },
);
